import React from 'react';
import {Link} from 'react-router-dom';
import {useRoute} from '../../routing/RouteProvider';
import {getMediaUrl} from '../../api/hooks';

const LocationsCard = ({location: {medialist, id, title, address, zip, city}}) => {
    const url = useRoute('locationDetails', {id});
    const image = medialist && medialist[0];

    return (
        <Link to={url} style={{color: '#7a82a6'}} aria-label="location">
            <article className="atbd_single_listing_wrapper">
                {image &&
                    <figure className="atbd_listing_thumbnail_area">
                        <div className="atbd_listing_image">
                            <img src={getMediaUrl(image.id, image.context, 'medium')} alt="location_image" />
                        </div>
                    </figure>
                }
                <div className="atbd_listing_info">
                    <div className="atbd_content_upper">
                        <h4 className="atbd_listing_title">{title}</h4>
                        <div className="atbd_listing_data_list">
                            <ul>
                                <li>
                                    <p><span className="la la-map-marker" />{address}</p>
                                </li>
                                <li>
                                    <p><span className="la la-building" />{zip}, {city}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </article>
        </Link>
    );
};

export default LocationsCard;
